import { stringify } from "qs";
import { fetch, getHeaders, makeRequest } from "$utils/utils";
import config from "./config";
import { ProjectType } from "$types";
import { GetAllResponse } from "$types/Request";
import { Services, SERVICES_URL } from "$utils/typeConstants";

const url = config.api_url;

export enum ERRORS {
  MISSING_FIELD = "Donnée manquante !",
  ADD_ERROR = "Une erreur s'est produite lors de l'ajout du projet",
  PROJECT_EXISTS = "Cette entreprise a déjà un projet existant avec ce code projet, veuillez modifier les informations ou annuler la création",
  NOT_FOUND = "Aucun projet trouvés",
  DELETE_ERROR = "Une erreur s'est produite lors de la suppression du projet.",
}

export const AddProject = async (token: string, data: ProjectType) => {
  try {
    const res = await makeRequest(
      `${url}/api/projects`,
      "POST",
      data,
      getHeaders(token)
    );
    if (!res || !res.data || !res.data.status) {
      throw new Error(ERRORS.ADD_ERROR);
    }
    return res.data.data;
  } catch (err) {
    let error = (err as any)?.response?.data?.message;
    if (
      error &&
      (error.includes("already exists") || error.includes("duplicate"))
    ) {
      error = ERRORS.PROJECT_EXISTS;
    } else {
      error = ERRORS.ADD_ERROR;
    }
    return { error };
  }
};

export const UpdateProject = async (token: string, data: any, id?: string) => {
  try {
    const res = await makeRequest(
      `${url}/api/projects/${id}`,
      "PUT",
      data,
      getHeaders(token)
    );
    if (!res || !res.data || !res.data.status) {
      throw new Error(ERRORS.ADD_ERROR);
    }
    return res.data.data;
  } catch (err) {
    let error = (err as any)?.response?.data?.message;
    if (
      error &&
      (error.includes("already exists") || error.includes("duplicate"))
    ) {
      error = ERRORS.PROJECT_EXISTS;
    } else {
      error = ERRORS.ADD_ERROR;
    }
    return { error };
  }
};

// pagination
export const getProjects = async (
  params
): Promise<GetAllResponse<ProjectType[]>> => {
  try {
    const { data } = await fetch(`/api/projects?${stringify(params)}`);
    return data;
  } catch (err) {
    throw new Error(err?.message);
  }
};

export const getProjectsWithWarehouse = async (params: {
  companyId?: string;
  contributorCompanyId?: string;
  warehouseId?: string;
  nameCode?: string;
  isActive?: boolean;
  companyDisable?: boolean;
  status?: string;
  rowsPerPage?: number;
  page?: number;
}): Promise<GetAllResponse<ProjectType[]>> => {
  try {
    const response = await fetch(
      `/api/project-list/warehouse?${stringify(params)}`,
      {},
      SERVICES_URL[Services.GATEWAY_API]
    );
    return response.data;
  } catch (err) {
    throw new Error(err?.message);
  }
};

// TODO: replace GetProject with getProjectById
export const getProjectById = async (id: string) => {
  try {
    const { data } = await fetch(`/api/projects/${id}`);
    return data.data;
  } catch (err) {
    throw new Error(err?.message);
  }
};

// export const GetProjects = async (
//   token: string,
//   company: string | null = null,
//   offset = 0,
//   limit = 80
// ) => {
//   try {
//     const res = await makeRequest(
//       `${url}/api/projects/${offset}/${limit}?company=${company}`,
//       "GET",
//       undefined,
//       getHeaders(token)
//     );
//     if (!res || !res.data || !res.data.status) {
//       throw new Error(ERRORS.NOT_FOUND);
//     }
//     return res.data.data;
//   } catch (err) {
//     return [];
//   }
// };

export const GetProject = async (token: string, id: string) => {
  try {
    const res = await makeRequest(
      `${url}/api/projects/${id}`,
      "GET",
      undefined,
      getHeaders(token)
    );
    if (!res || !res.data || !res.data.status) {
      throw new Error(ERRORS.ADD_ERROR);
    }
    return res.data.data;
  } catch (err) {
    return null;
  }
};

export const GetChantierFileTemplate = async (token: string, id: string) => {
  try {
    const res = await makeRequest(
      `${url}/api/file/project/${id}`,
      "GET",
      undefined,
      getHeaders(token)
    );
    if (!res || !res.data || !res.data.status) {
      return "/uploads/template import chantier.csv";
    }
    return res.data.data.url;
  } catch (err) {
    return "/uploads/template import chantier.csv";
  }
};

export const DisabledProject = async (token: string, id?: string) => {
  try {
    const res = await makeRequest(
      `${url}/api/projects/disable/${id}`,
      "POST",
      {},
      getHeaders(token)
    );
    if (!res || !res.data || !res.data.status) {
      throw new Error(ERRORS.ADD_ERROR);
    }
    return res.data.data;
  } catch (err) {
    let error = (err as any)?.response?.data?.message;
    if (error && error.includes("already exists")) {
      error = ERRORS.PROJECT_EXISTS;
    } else {
      error = ERRORS.ADD_ERROR;
    }
    return { error };
  }
};

export const EnableProject = async (token: string, id?: string) => {
  try {
    const res = await makeRequest(
      `${url}/api/projects/enable/${id}`,
      "POST",
      {},
      getHeaders(token)
    );
    if (!res || !res.data || !res.data.status) {
      throw new Error(ERRORS.ADD_ERROR);
    }
    return res.data.data;
  } catch (err) {
    let error = (err as any)?.response?.data?.message;
    if (error && error.includes("already exists")) {
      error = ERRORS.PROJECT_EXISTS;
    } else {
      error = ERRORS.ADD_ERROR;
    }
    return { error };
  }
};

export const DeleteProject = async (token: string, id: string) => {
  try {
    const res = await makeRequest(
      `${url}/api/projects/${id}`,
      "DELETE",
      undefined,
      getHeaders(token)
    );
    if (!res || !res.data || !res.data.status) {
      throw new Error("Error when deleting project");
    }
    return res.data.data;
  } catch (err) {
    throw new Error(ERRORS.DELETE_ERROR);
  }
};
